import TranslateButton from './TranslateButton';

export default TranslateButton;
